export default __webpack_public_path__ + "static/4-80f57e8448743eb0b3c82eac6248d326.jpeg";